import React from 'react';
import { Trophy, LogOut, BookOpen, Medal, Award, TrendingUp } from 'lucide-react';
import './StudentHeader.css';
import ProfileAvatar from './ProfileAvatar';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const StudentHeader = () => {
  const { user, logoutUser } = useUser();
  const gradeLabel = user?.grade?.name || `Grade ${user?.gradeId || '?'}`;
  const navigate = useNavigate();
  // Empty dependency array means this runs once on mount



  const onLogout = () => {
    logoutUser();
    window.location.href = "/login";
  };

  const onClickPoints = () => {
    navigate('/student/learning-journey');
  };

  const onClickLeaderboard = () => {
    navigate('/leaderboards');
  };

  const onClickBadges = () => {
    navigate('/trophy-room');
  };

  const onClickPerformance = () => {
    navigate('/student/progress');
  };

  const onClickStudy = () => {
    navigate('/student/home')
  };

  return (
    <header className="student-header">
      <div className="header-left">
        <ProfileAvatar username={user?.username} />
        <div className="greeting-text">
          <div className="greeting-row">
            <h2 className="greeting">{user?.username?.split('.')[0] || 'Explorer'}</h2>
            <div className="grade-badge">
              <BookOpen size={13} />
              <span>{gradeLabel}</span>
            </div>
          </div>
          <span className="welcome-back">Ready for your next lesson?</span>
        </div>
      </div>

      <div className="header-right">
        <button className="student-header-btn" onClick={onClickStudy} title="Study">
          <BookOpen size={20} className="student-header-btn-icon" />
          <span>Study</span>
        </button>
        <button className="student-header-btn" onClick={onClickPerformance} title="My Performance">
          <TrendingUp size={20} className="student-header-btn-icon" />
          <span>Performance</span>
        </button>
        <button className="student-header-btn" onClick={onClickBadges} title="My Badges">
          <Award size={20} className="student-header-btn-icon" />
          <span>Badges</span>
        </button>
        <button className="student-header-btn" onClick={onClickLeaderboard} title="View Leaderboard">
          <Medal size={20} className="student-header-btn-icon" />
          <span>Leaderboard</span>
        </button>
        <div className="student-header-btn" onClick={onClickPoints}>
          <Trophy size={20} className="student-header-btn-icon" />
          <span>{user?.points || 0}</span>
        </div>
        <button className="logout-btn" onClick={onLogout} title="Logout">
          <LogOut size={20} />
        </button>
      </div>
    </header>
  );
};

export default StudentHeader;